import { render } from "./BreadcrumbsApp.vue?vue&type=template&id=88b27df4&ts=true"
import script from "./BreadcrumbsApp.vue?vue&type=script&lang=ts&setup=true"
export * from "./BreadcrumbsApp.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/src/PortalSite/Portal/ClientApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"views/_Layout/BreadcrumbsApp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "88b27df4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('88b27df4', __exports__)) {
    api.reload('88b27df4', __exports__)
  }
  
  module.hot.accept("./BreadcrumbsApp.vue?vue&type=template&id=88b27df4&ts=true", () => {
    api.rerender('88b27df4', render)
  })

}


export default __exports__